import { configureStore } from "@reduxjs/toolkit";
import AirportCodeReducer from "./airport/AirportCodeSlice";
import FlightFiltersReducer from "./flights-filter/FlightFiltersSlice";
import OTPFlightFiltersReducer from "./flights-filter/OTPFlightFiltersSlice";
import OrganizationFiltersReducer from "./organization-filter/OrganizationFilterSlice";
import PaxFiltersReducer from "./pax-filter/PaxFilterSlice";
import { PassengerFlowReducer } from "./pax-flow/passengerFlowSlice";
import PaxSettingReducer from "./pax-touchpoints/PaxSettingsSlice";
import ResourceAllocationFiltersReducer from "./resource-allocation-filter/ResourceAllocationFilterSlice";
import RoleFiltersReducer from "./role-filter/RoleFilterSlice";
import ScreenNameReducer from "./screen/ScreenNameSlice";
import { weatherDisruptionReducer } from "./weather-disruption/WeatherDisruptionSlice";

//Add the logger middleware only in development mode
const middlewares = [] as any;

const Store = configureStore({
  reducer: {
    flightScheduleFilters: FlightFiltersReducer,
    otpFlightFilters: OTPFlightFiltersReducer,
    resourceAllocationFilters: ResourceAllocationFiltersReducer,
    paxFilters: PaxFiltersReducer,
    roleFilters: RoleFiltersReducer,
    organizationFilters: OrganizationFiltersReducer,
    airportCode: AirportCodeReducer,
    paxFlow: PassengerFlowReducer,
    weatherDisruption: weatherDisruptionReducer,
    paxSettings: PaxSettingReducer,
    screenName: ScreenNameReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
});

export default Store;
